if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      
      if (this.productInfo && Shopify.postLinksRetry) {
        this.productInfo.initShareLinks();
      }

      // Inicializar listeners
      this.initThumbnailListeners();
      this.initViewerListener();
      
      if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
        this.removeListSemantic();
      }
    }

    initThumbnailListeners() {
      if (!this.elements.thumbnails) return;

      const thumbnailButtons = this.elements.thumbnails.querySelectorAll('[data-target] button');
      
      if (thumbnailButtons.length === 0) {
        console.warn('No thumbnail buttons found');
        return;
      }

      thumbnailButtons.forEach((button) => {
        const parentLi = button.closest('[data-target]');
        if (!parentLi) return;

        const mediaId = parentLi.dataset.target;
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.setActiveMedia(mediaId, false);
        });
      });
    }

    initViewerListener() {
      if (!this.elements.viewer) return;

      this.elements.viewer.addEventListener('slideChanged', (event) => {
        if (!this.elements.thumbnails) return;
        
        const currentElement = event.detail?.currentElement;
        if (!currentElement) return;

        const mediaId = currentElement.dataset.mediaId;
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        
        if (thumbnail) {
          this.setActiveThumbnail(thumbnail);
        }
      });
    }

    setActiveMedia(mediaId, prepend) {
      if (!mediaId) return;

      // Remover clase is-active de todos
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      // Agregar clase is-active al media seleccionado
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) {
        console.warn(`Media with id ${mediaId} not found`);
        return;
      }

      activeMedia.classList.add('is-active');

      if (prepend && activeMedia.parentElement) {
        activeMedia.parentElement.prepend(activeMedia);
        
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumbnail && activeThumbnail.parentElement) {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
        }
        
        if (this.elements.viewer.slider && this.elements.viewer.slider.resetPages) {
          this.elements.viewer.slider.resetPages();
        }
      }

      this.preventStickyHeader();

      // Scroll suave
      window.setTimeout(() => {
        if (this.elements.thumbnails && activeMedia.parentElement) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);

      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      if (activeThumbnail) {
        this.setActiveThumbnail(activeThumbnail);
        const mediaPosition = activeThumbnail.dataset.mediaPosition;
        this.announceLiveRegion(activeMedia, mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      // Remover aria-current de todos los botones
      this.elements.thumbnails.querySelectorAll('button').forEach((element) => {
        element.removeAttribute('aria-current');
      });

      // Agregar aria-current al thumbnail actual
      const button = thumbnail.querySelector('button');
      if (button) {
        button.setAttribute('aria-current', 'true');
      }

      // Scroll del thumbnail si es necesario
      if (this.elements.thumbnails.isSlideVisible && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
        return;
      }

      if (this.elements.thumbnails.slider && this.elements.thumbnails.slider.scrollTo) {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      if (!this.elements.liveRegion) return;

      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;

      const handleImageLoad = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', 'false');
        
        if (window.accessibilityStrings && window.accessibilityStrings.imageAvailable) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
        }

        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'true');
        }, 2000);
      };

      if (image.complete) {
        handleImageLoad();
      } else {
        image.addEventListener('load', handleImageLoad, { once: true });
      }
    }

    playActiveMedia(activeItem) {
      if (window.pauseAllMedia) {
        window.pauseAllMedia();
      }

      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia && deferredMedia.loadContent) {
        deferredMedia.loadContent(false);
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer || !this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      if (this.elements.viewer.sliderItems) {
        this.elements.viewer.sliderItems.forEach(slide => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  });
}